import type { Theme } from '@emotion/react';

import { CARD_VARIANTS } from '@didaskill/ui/design-system';

export enum LESSON_CARD_VARIANTS {
  TO_START = 'TO_START',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  DISABLED = 'DISABLED',
  LOCKED = 'LOCKED',
}

export const LESSON_CARD_VARIANT_MAPPING: Record<LESSON_CARD_VARIANTS, CARD_VARIANTS> = {
  [LESSON_CARD_VARIANTS.COMPLETED]: CARD_VARIANTS.SUCCESS,
  [LESSON_CARD_VARIANTS.IN_PROGRESS]: CARD_VARIANTS.NEUTRAL,
  [LESSON_CARD_VARIANTS.DISABLED]: CARD_VARIANTS.DISABLED,
  [LESSON_CARD_VARIANTS.LOCKED]: CARD_VARIANTS.PRIMARY,
  [LESSON_CARD_VARIANTS.TO_START]: CARD_VARIANTS.NEUTRAL,
};

export const LESSON_CARD_PROGRESS_COLOR_MAPPING = (
  theme: Theme,
): Record<LESSON_CARD_VARIANTS, string | null> => ({
  [LESSON_CARD_VARIANTS.COMPLETED]: theme.colors.success[500],
  [LESSON_CARD_VARIANTS.IN_PROGRESS]: theme.colors.primary[500],
  [LESSON_CARD_VARIANTS.DISABLED]: null,
  [LESSON_CARD_VARIANTS.LOCKED]: null,
  [LESSON_CARD_VARIANTS.TO_START]: null,
});
